<div id="main" style="width: 100%" [ngStyle]="{ height: '400px' }"></div>
<div id="mainw" style="width: 100%" [ngStyle]="{ height: '400px' }"></div>
<div id="mainh" style="width: 100%" [ngStyle]="{ height: '400px' }"></div>

<!--
@if (floorCharts) {
  charts:
  <div class="charts-container">
    <h2>A/C Running Time: Parcels Building (Before vs. After)</h2>
    @for (chart of floorCharts; track $index) {
      <div class="floor-chart">
        <div echarts [options]="chart.option" style="height: 300px; width: 100%"></div>
        <p class="insight">Floor {{ chart.floor }}: {{ chart.reductionPercent }}% reduction (P1: {{ chart.p1Avg }}h/day → P2: {{ chart.p2Avg }}h/day)</p>
      </div>
    }
  </div>
}

-->
